'use client';

import { Box, Typography, Button } from '@mui/material';

export default function SectionV4() {
  const cards = [
    { img: '/reddit.gif', title: 'Discord', link: 'https://discord.com/invite/mN8ENbzEMJ' },
    { img: '/insta.gif', title: 'Instagram', link: 'https://www.instagram.com/funizzle/' },
    { img: '/linkedin.gif', title: 'LinkedIn', link: 'https://www.linkedin.com/company/funizzle/' },
  ];

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        overflowX: 'hidden',
      }}
    >
      <Box
        sx={{
          textAlign: 'center',
          maxWidth: { xs: '100%', sm: '800px', md: '1000px', lg: '1200px' },
          mt: -4,
          width: '100%',
          px: { xs: 2, sm: 3, md: 4 },
        }}
      >
        <Typography
          sx={{
            color: 'white',
            fontFamily: 'Rammetto One',
            textTransform: 'uppercase',
            fontWeight: 800,
            fontSize: { xs: 32, sm: 40, md: 48, lg: 56, xl: 60 },
            lineHeight: 1.1,
          }}
        >
          Interested????
        </Typography>

        <Typography
          sx={{
            color: 'rgb(200,200,200)',
            mt: 2,
            letterSpacing: '2px',
            textTransform: 'uppercase',
            fontFamily: 'Poppins',
            fontSize: { xs: 12, sm: 19, md: 24 },
          }}
        >
          Join the Community
        </Typography>

        {/* CARDS */}
        <Box
          sx={{
            mt: { xs: 2, sm: 4, lg: 6 },
            width: '100%',
            display: 'grid',

            // ✅ gaps
            gap: { xs: '7px', sm: '12px', md: '12px', lg: '12px' },

            // ✅ desktop/tablet same layout (3 cards in a row), mobile 1 col
            justifyContent: 'center',
            gridTemplateColumns: {
              xs: '1fr',
              sm: 'repeat(3, auto)',
            },
          }}
        >
          {cards.map((card, index) => (
            <Box
              key={index}
              sx={{
                width: '100%',
                maxWidth: { xs: '90%', sm: 260, md: 280, lg: 330 }, // ✅ stable width, slightly smaller on tablet
                justifySelf: 'center',

                display: 'flex',
                flexDirection: { xs: 'row', sm: 'column' },
                alignItems: 'center',
                gap: 2,

                px: { xs: 2, sm: 2.2 },

                // ✅ tablet padding thori kam
                py: { xs: 3, sm: 1.7, md: 1.7, lg: 2 },

                borderRadius: '20px',
                backdropFilter: 'blur(10px)',
                backgroundColor: 'rgba(255,255,255,0.1)',
                boxSizing: 'border-box',
                overflow: 'hidden',

                // ✅ SAME height on ALL tablets (sm & md)
                height: { xs: 'auto', sm: 210, md: 210, lg: 340, xl: 360 },
              }}
            >
              <Box
                component="img"
                src={card.img}
                alt={card.title}
                sx={{
                  width: { xs: 80, sm: 92, md: 102, lg: 180 },
                  height: { xs: 80, sm: 92, md: 102, lg: 180 },
                  flexShrink: 0,
                  objectFit: 'contain',
                }}
              />

              <Box
                sx={{
                  flex: 1,
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: { xs: 'flex-start', sm: 'center' },
                  width: '100%',
                  justifyContent: 'space-between',
                }}
              >
                <Typography
                  sx={{
                    color: 'white',
                    fontFamily: 'Poppins',
                    fontWeight: 600,
                    textTransform: 'capitalize',
                    textAlign: { xs: 'left', sm: 'center' },
                    fontSize: { xs: 16, sm: 16, md: 17, lg: 26 },
                    lineHeight: 1.15,
                  }}
                >
                  {card.title}
                </Typography>

                <Button
                  href={card.link}
                  target="_blank"
                  variant="contained"
                  sx={{
                    mt: 1.2,
                    width: { xs: '100%', sm: '80%', md: '85%' },
                    bgcolor: 'white',
                    color: '#FF2EC6',
                    textTransform: 'uppercase',
                    fontFamily: 'Poppins',
                    fontWeight: 600,
                    borderRadius: { xs: '8px', sm: '12px' },

                    // ✅ tablet button thora compact
                    py: { xs: 1.1, sm: 0.9, md: 0.9, lg: 1.2 },
                    fontSize: { xs: 12, sm: 12, md: 12, lg: 14 },
                    '&:hover': { bgcolor: 'white' },
                  }}
                >
                  Join
                </Button>
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
}
